import axios from 'axios';
import { configRefs } from '@utils/constants';

const saveCloudEntry = async (componentEntryId, cloudEntry) => {
  if (!componentEntryId) {
    return;
  }
  const requestBody = {
    entryID: componentEntryId,
    googleDrive: cloudEntry.googleDrive !== undefined ? {
      uri: cloudEntry.googleDrive.fileId,
      modified: Math.round(cloudEntry.googleDrive.modifiedAt.getTime() / 1000)
    } : undefined,
    oneDrive: cloudEntry.oneDrive !== undefined ? {
      uri: cloudEntry.oneDrive.fileId,
      modified: Math.round(cloudEntry.oneDrive.modifiedAt.getTime() / 1000)
    } : undefined
  };
  await axios.put(`${await configRefs.apis.userdata.get()}/api/CloudEntries`, requestBody, {
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  });
};

export { saveCloudEntry };
//# sourceMappingURL=request.save-cloud-entry.js.map
